var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLike({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.572 0.555033C10.2967 0.555033 10.0721 0.801034 10.0721 1.10265V5.3467L8.0724 10.9598V22.4598C8.2794 23.0973 8.91992 23.555 9.57216 23.555H19.0707C20.174 23.555 21.0703 22.5732 21.0703 21.3646C21.0703 20.9132 20.9395 20.4982 20.7266 20.1495C21.5058 19.85 22.0702 19.0329 22.0702 18.0788C22.0702 17.5419 21.8944 17.0563 21.6015 16.6756C22.1815 16.2927 22.5701 15.5889 22.5701 14.7931C22.5701 14.2562 22.3944 13.7706 22.1014 13.3899C22.6814 13.0069 23.07 12.3032 23.07 11.5074C23.07 10.2988 22.1737 9.31694 21.0703 9.31694H13.759C14.0636 8.2602 14.5714 6.36921 14.5714 5.4836C14.5714 3.42148 13.1927 0.555033 11.8374 0.555033H10.572ZM0.573585 9.31694C0.431029 9.31694 0.294332 9.38753 0.198644 9.50518C0.102956 9.62283 0.0560886 9.77685 0.0736638 9.93301L1.57343 23.0759C1.60467 23.3497 1.82143 23.555 2.07335 23.555H6.57264C6.84798 23.555 7.07256 23.3112 7.07256 23.0074V9.86456C7.07256 9.56294 6.84798 9.31694 6.57264 9.31694H0.573585ZM4.82291 19.7217C5.23691 19.7217 5.57279 20.0896 5.57279 20.5431C5.57279 20.9966 5.23691 21.3646 4.82291 21.3646C4.40892 21.3646 4.07303 20.9966 4.07303 20.5431C4.07303 20.0896 4.40892 19.7217 4.82291 19.7217Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.d558e0df21c2316fbe6a5c4bec7aadda.svg";
export { ForwardRef as ReactComponent };